import { render, staticRenderFns } from "./BaseVideoPlayer.vue?vue&type=template&id=501fb085&scoped=true&"
import script from "./BaseVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./BaseVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./BaseVideoPlayer.vue?vue&type=style&index=0&id=501fb085&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501fb085",
  null
  
)

export default component.exports